// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".calendar-wrapper {\n  width: 200px;\n  text-align: center;\n}", "",{"version":3,"sources":["webpack://./src/app/common/calendar/calendar.component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,kBAAA;AACJ","sourcesContent":[".calendar-wrapper{\r\n    width: 200px;\r\n    text-align: center;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
